import { SCHEMA_TYPE_ENUM } from '../util/types'; // if you already import types elsewhere, ignore this line

export const listingFields = [
  {
    key: 'bagSize',
    scope: 'public',
    schemaType: 'enum',
    enumOptions: [
      { option: '4oz', label: '4 oz' },
      { option: '8oz', label: '8 oz' },
      { option: '10oz', label: '10 oz' },
      { option: '12oz', label: '12 oz' },
      { option: '16oz', label: '16 oz' },
      { option: '2lb', label: '2 lb' },
      { option: '5lb', label: '5 lb' },
    ],
    filterConfig: {
      indexForSearch: true,
      filterType: 'SelectSingleFilter',
      label: 'Bag size',
      group: 'primary',
    },
    showConfig: { label: 'Bag size', isDetail: true },
    saveConfig: { label: 'Bag size', placeholderMessage: 'Select…', isRequired: false },
  },
  {
    key: 'roastType',
    scope: 'public',
    schemaType: 'enum',
    enumOptions: [
      { option: 'light', label: 'Light' },
      { option: 'medium', label: 'Medium' },
      { option: 'dark', label: 'Dark' },
    ],
    filterConfig: {
      indexForSearch: true,
      filterType: 'SelectSingleFilter',
      label: 'Roast',
      group: 'primary',
    },
    showConfig: { label: 'Roast', isDetail: true },
    saveConfig: { label: 'Roast', placeholderMessage: 'Select…', isRequired: false },
  },
  {
    key: 'grind',
    scope: 'public',
    schemaType: 'enum',
    enumOptions: [
      { option: 'whole', label: 'Whole bean' },
      { option: 'ground', label: 'Ground' },
    ],
    filterConfig: {
      indexForSearch: true,
      filterType: 'SelectSingleFilter',
      label: 'Grind',
      group: 'secondary',
    },
    showConfig: { label: 'Grind', isDetail: true },
    saveConfig: { label: 'Grind', placeholderMessage: 'Select…', isRequired: false },
  },
  {
    key: 'caffeinated',
    scope: 'public',
    schemaType: 'boolean',
    filterConfig: {
      indexForSearch: true,
      label: 'Caffeinated',
      group: 'secondary',
    },
    showConfig: { label: 'Caffeinated', isDetail: true },
    saveConfig: { label: 'Caffeinated', isRequired: false },
  },
];

// leave listingTypes as-is
export const listingTypes = [{ listingType: 'coffee' }];
export const enforceValidListingType = false;